import {useCallback} from 'react';
import {assert} from 'assert-ts';
import {HttpError} from 'api/http/types';
import {usePutTaskStatusMutation} from 'services/tasks';
import type {ChangeRequest, SaveStatus} from '../types';
import {usePostChangeRequestCloseMutation} from '../changeRequestsApi';

export const useCloseChangeRequest = () => {
  const [postChangeRequestClose] = usePostChangeRequestCloseMutation();
  const [putTaskStatus] = usePutTaskStatusMutation();

  return useCallback(
    (
      changeRequestId: string,
      type: ChangeRequest['taskType'],
    ): Promise<SaveStatus | void> => {
      if (type === 'METADATA_IMPORT_CHANGE') {
        return postChangeRequestClose(changeRequestId).unwrap();
      }

      const taskId = parseInt(changeRequestId);
      if (isNaN(taskId) && changeRequestId.toString().length === 0) {
        assert.soft(false, 'saveChangeRequest: could not parse id', {
          id: changeRequestId,
        });
        return Promise.resolve({
          status: 'Failed',
          error: new HttpError(400, '', 'Invalid id'),
        });
      }

      return putTaskStatus({id: taskId, status: 'COMPLETED'}).unwrap();
    },
    [postChangeRequestClose, putTaskStatus],
  );
};
